<template src="./Task.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import BrandSelect from "@/components/components/BrandSelect"
import TopMenu from "@/components/competitors/components/topMenu"
import CountrySelect from "@/components/components/countrySelect/CountrySelect"

const {mapGetters, mapActions} = createNamespacedHelpers('competitors/task');

export default {
  name: "CompetitorsTask",
  components: {
    BrandSelect,
    TopMenu,
    CountrySelect,
  },
  data() {
    return {
      showOverlay: false,
      taskData: {
        brand: null,
        requestBrand: null,
        articleModel: null,
        region: null
      },
      fieldReset: true,
      brandToggle: false,
      brandEditToggle: false,
    }
  },
  methods: {
    ...mapActions(['SAVE']),
    addTask() {
      // check is fill require fields
      if (this.taskData.brand == null || this.taskData.requestBrand == '' || this.taskData.articleModel == '') {
        this.$bvModal.show('emptyRequireData');
        return;
      }
      // prepare requests
      let requests = []
      for (let key in this.taskData.requests) {
        requests.push(this.taskData.requests[key].query)
      }
      let taskData = Object.assign({}, this.taskData)
      taskData.requests = requests

      this.SAVE({th: this, task: taskData})
    },
    brandsChange(brand) {
      if (brand.length == 0) {
        return
      }
      this.taskData['brand'] = brand.id
      this.taskData.requestBrand = brand.name
      this.brandToggle = true
      this.$forceUpdate()
    },
    brandClean() {
      this.fieldReset = false
      this.brandToggle = false
      this.$nextTick(() => {
        this.fieldReset = true
      })
    },
    regionChange(region) {
      this.taskData['region'] = region
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('competitors') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
  created() {
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}

</style>